import { Controller } from "@hotwired/stimulus"
import { postJson } from "./news_api"

// 記事のお気に入り。記事カードごとリンクになっている場所に置くので、
// クリックは必ず止める（止めないと押した瞬間に記事詳細へ飛ぶ）。
export default class extends Controller {
  static values = {
    articleId: Number,
    favorited: Boolean,
    loginPath: { type: String, default: "/login" }
  }

  async toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.busy) return
    this.busy = true

    const on = this.favoritedValue
    try {
      const data = await postJson(
        on ? `/news/favorites/${this.articleIdValue}` : "/news/favorites",
        {
          method: on ? "DELETE" : "POST",
          body: on ? null : { article_id: this.articleIdValue },
          loginPath: this.loginPathValue
        }
      )
      if (data && data.ok !== false) this.favoritedValue = data.favorited
    } catch (e) {
      // 通信に失敗しただけなので見た目は変えない（変えると付いたように見えて嘘になる）
      console.error("favorite toggle failed", e)
    } finally {
      this.busy = false
    }
  }

  favoritedValueChanged() {
    const on = this.favoritedValue
    this.element.setAttribute("aria-pressed", on ? "true" : "false")
    this.element.setAttribute("title", on ? "お気に入りから外す" : "お気に入りに入れる")
    this.element.classList.toggle("text-rose-500", on)
    this.element.classList.toggle("text-gray-400", !on)
    const svg = this.element.querySelector("svg")
    if (svg) svg.setAttribute("fill", on ? "currentColor" : "none")
  }
}
